import menuService from "Assets/js/components/menuService";

const actions = {
  async brandsmenu(context) {
    if (!context.getters.brandsmenu) {
      const MenuService = menuService.getInstance();
      await MenuService.getBrandsMenu((response) => {
        context.commit('brandsmenu', response);
      });
    }
  },
  async brandmenus(context) {
    if (!context.getters.brandmenu) {
      const MenuService = menuService.getInstance();
      await MenuService.getBrandMenus((response) => {
        context.commit('brandmenus', response);
      });
    }
  },
  async usp(context) {
    if (!context.getters.usp) {
      const MenuService = menuService.getInstance();
      await MenuService.getUSP((response) => {
        context.commit('usp', response);
      });
    }
  }
};

export default actions;
